import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: { //存放数据，和data类似
  },
  getters: { //用来修改 state 和 getters 里面的数据
  },
  mutations: { //相当于计算属性
  },
  actions: { //vuex中用于发起异步请求
  },
  modules: { //拆分模块
  }
})
